
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { FileReferenceModel } from './Entities.GormCrm.FileReference';
import { CompanyModel } from './Entities.GormCrm.Company';
import { TransferPlanModel } from './Entities.GormCrm.TransferPlan';
import { Model, ModelProperty } from 'models/Model';


export class TransferModel extends Model<TransferModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'transfer.property.id', isHidden: true },
		{ name: 'created', type: 'Date', languageString: 'transfer.property.created', isHidden: true },
		{ name: 'fromCompanyId', type: 'guid', languageString: 'transfer.property.fromCompanyId' },
		{ name: 'toCompanyId', type: 'guid', languageString: 'transfer.property.toCompanyId' },
		{ name: 'userId', type: 'guid', languageString: 'transfer.property.userId' },
		{ name: 'fileReferenceId', type: 'guid', languageString: 'transfer.property.fileReferenceId' },
		{ name: 'fileReference', type: 'FileReferenceModel', languageString: 'transfer.property.fileReference', isHidden: true, isObject: true, new: () => { return new FileReferenceModel }, properties: () => { return FileReferenceModel.classProperties } },
		{ name: 'fromCompany', type: 'CompanyModel', languageString: 'transfer.property.fromCompany', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'toCompany', type: 'CompanyModel', languageString: 'transfer.property.toCompany', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'transferPlans', type: 'TransferPlanModel[]', languageString: 'transfer.property.transferPlans', isHidden: true, isArray: true, isObject: true, new: () => { return new TransferPlanModel }, properties: () => { return TransferPlanModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public created?: Date;
	public fromCompanyId?: string;
	public toCompanyId?: string;
	public userId?: string;
	public fileReferenceId?: string;
	public fileReference?: FileReferenceModel;
	public fromCompany?: CompanyModel;
	public toCompany?: CompanyModel;
	public transferPlans: TransferPlanModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.created = undefined;
		this.fromCompanyId = undefined;
		this.toCompanyId = undefined;
		this.userId = undefined;
		this.fileReferenceId = undefined;
		this.fileReference = undefined;
		this.fromCompany = undefined;
		this.toCompany = undefined;
		this.transferPlans = [];
		
	}
	getProperties(){
		return TransferModel.classProperties;
	}
}

